let oneTimeCallbacks = [];

/**
 * Allows registering a one time callback which takes google-maps api as an argument.
 */
export default {
  install(Vue) {
    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$googleMaps = {
      once: cb => {
        if (window.google && window.google.maps) {
          cb(window.google.maps);

          return;
        }

        oneTimeCallbacks.push(cb);
      }
    };

    window.googleMapApiInit = () => {
      oneTimeCallbacks.forEach(cb => cb(window.google.maps));
      oneTimeCallbacks = [];
    };

    const script = document.createElement('script');
    script.setAttribute(
      'src',
      'https://maps.googleapis.com/maps/api/js?key=AIzaSyA54vBDE1T4-0MHenXaJ17VUUqyO0ZzaTo&libraries=places&v=weekly&callback=googleMapApiInit'
    );
    script.setAttribute('async', '');

    document.body.append(script);
  }
};
